import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import DownloadIcon from '../../../assets/download.png';
import style from './structureblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchStructureInfo } from '../../../services/api'; // Новая функция

const StructureBlock = () => {
  const { settings } = useAccessibility();
  const [structureInfo, setStructureInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Accessibility-aware colors
  const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
  const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
  const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchStructureInfo();
        // Данные теперь в response.data[0].attributes
        setStructureInfo(response.data[0].attributes);
        console.log('Structure data:', response.data[0].attributes);
      } catch (err) {
        console.error('Error fetching structure info:', err);
        setError('Не удалось загрузить данные. Пожалуйста, попробуйте позже.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Загрузка структуры...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!structureInfo) {
    return <div>Данные не найдены</div>;
  }

  return (
    <Block
      flexDirection='column'
      justifyContent='start'
      alignItems='start'
      width="75%"
      height='fit-content'
      background={backgroundColor}
      header='СТРУКТУРА И ОРГАНЫ УПРАВЛЕНИЯ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИЕЙ'
      headerColor={textColor}
      id='structure'
      aria-label="Структура и органы управления образовательной организацией"
      role="region"
    >
      <FadeIn>
        <div className={style.content}>
          <section aria-labelledby="structure-intro">
            <h3>
            Наименование структурного подразделения (органа управления)
            </h3>
            <p id="structure-intro" className={style.intro} style={{ color: textColor }}>
              {structureInfo.Description}
            </p>
          </section>
          
          <h2 className={style.sectionHeader} style={{ color: textColor }}>
            Руководство ГБУ ДО КК "СШОР "Самбо" г. Краснодар
          </h2>
          
          <div className={style.structureList} role="list">
              <section className={style.unit}>
                <h3 className={style.unitName} style={{ color: textColor }}>
                  Исполняющий обязанности директора
                </h3>
                <div className={style.unitInfo}>
                  <div className={style.infoRow}>
                    <span className={style.director}>{structureInfo.DirectorFullName}</span>
                  </div>
                </div>
              </section>

            {structureInfo.OrganizationManagement?.map((unit) => (
              <section 
                key={unit.id}
                id={`unit-${unit.id}`}
                className={style.unit}
                aria-labelledby={`unit-${unit.id}-header`}
                role="listitem"
              >
                <h3 id={`unit-${unit.id}-header`} className={style.unitName} style={{ color: textColor }}>
                  {unit.AreaOfWork}
                </h3>
                <div className={style.unitInfo}>
                  <div className={style.infoRow}>
                    <span className={style.label}>{unit.Job}</span>
                    <span>{unit.FullName}</span>
                  </div>
                </div>
              </section>
            ))}
          </div>

          <h2 className={style.sectionHeader} style={{ color: textColor }}>
            Обособленные структурные подразделения
          </h2>
          
          <div className={style.branchesGrid}>
            {structureInfo.FilialManagement?.map((branch) => (
              <div key={branch.id} className={style.branchCard}>
                <h3 className={style.branchName} style={{ color: textColor }}>{branch.RegionName}</h3>
                <div className={style.branchInfo}>
                  <div className={style.infoRow}>
                    <span className={style.label}>Руководитель:</span>
                    <span>{branch.FullName}</span>
                  </div>
                  <div className={style.infoRow}>
                    <span className={style.label}>Адрес:</span>
                    <span>{branch.Address}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </FadeIn>
    </Block>
  );
};

export default StructureBlock;